// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 768px) {\nspan[data-v-59c4e55a],\n  p[data-v-59c4e55a] {\n    font-size: 12px !important;\n}\n.calendar-card__wrapper[data-v-59c4e55a] {\n    width: unset;\n}\n.calendar-card[data-v-59c4e55a] {\n    padding-right: 5px;\n    padding-left: 10px;\n}\n}\n.assistence-details-label[data-v-59c4e55a] {\n  color: #3F5B60;\n}", ""]);
// Exports
module.exports = exports;
